Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.PrintJobOrientation = module.exports.default = {
	LANDSCAPE: "landscape",
	PORTRAIT: "portrait"
};